<template>
  <div>
    <div class="card custom-card">
      <div class="card-body pt-3 pl-3 pr-3 pb-3">
        <h3 class="left-title mb-3">COVID-19 Data Explorer</h3>
        <span class="left-download">Download the complete Vaccine Data</span>
        <br />
        <a href="">COVID-19 dataset.</a>
      </div>
    </div>
    <div class="card custom-card mt-4">
      <div class="card-body pt-3 pl-3 pr-3 pb-2">
        <h5 class="font-weight-700">
          <i class="flaticon-search text-dark mr-2" />
          Type to add a region...
        </h5>
      </div>
    </div>
    <div class="mt-4">
      <div class="form-group row mb-0">
        <label for="inputEmail3" class="col-sm-3 col-form-label-xs text-white">
          Sort by
        </label>
        <div class="col-sm-7">
          <select
            class="form-control form-control-xs"
            id="inlineFormCustomSelect"
          >
            <option selected>Total Vaccinations</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>
        </div>
        <div class="col-sm-2">
          <i class="flaticon2-sort-down text-white" />
        </div>
      </div>
    </div>
    <ul class="list-group custom-card mt-3">
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input
            type="checkbox"
            class="form-check-input"
            id="exampleCheck1"
            checked
          />
          <label class="form-check-label" for="exampleCheck1">
            <h5 class="font-weight-700">Indonesia</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">2.75B</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input
            type="checkbox"
            class="form-check-input"
            id="exampleCheck1"
            checked
          />
          <label class="form-check-label" for="exampleCheck1">
            <h5 class="font-weight-700">Aceh</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">95M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input
            type="checkbox"
            class="form-check-input"
            id="exampleCheck1"
            checked
          />
          <label class="form-check-label" for="exampleCheck1">
            <h5 class="font-weight-700">Sumatera Utara</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">91M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input
            type="checkbox"
            class="form-check-input"
            id="exampleCheck1"
            checked
          />
          <label class="form-check-label" for="exampleCheck1">
            <h5 class="font-weight-700">Sumatera Barat</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">74M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input
            type="checkbox"
            class="form-check-input"
            id="exampleCheck1"
            checked
          />
          <label class="form-check-label" for="exampleCheck1">
            <h5 class="font-weight-700">Riau</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">68M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input
            type="checkbox"
            class="form-check-input"
            id="exampleCheck1"
            checked
          />
          <label class="form-check-label" for="exampleCheck1">
            <h5 class="font-weight-700">Jambi</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">57M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input
            type="checkbox"
            class="form-check-input"
            id="exampleCheck1"
            checked
          />
          <label class="form-check-label" for="exampleCheck1">
            <h5 class="font-weight-700">Sumatera Selatan</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">54M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input
            type="checkbox"
            class="form-check-input"
            id="exampleCheck1"
            checked
          />
          <label class="form-check-label" for="exampleCheck1">
            <h5 class="font-weight-700">Bengkulu</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">51M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input type="checkbox" class="form-check-input" id="exampleCheck1" />
          <label class="form-check-label" for="exampleCheck1">
            <h5>Lampung</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">49M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input type="checkbox" class="form-check-input" id="exampleCheck1" />
          <label class="form-check-label" for="exampleCheck1">
            <h5>Bangka Belitung</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">48M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input type="checkbox" class="form-check-input" id="exampleCheck1" />
          <label class="form-check-label" for="exampleCheck1">
            <h5>Kepulauan Riau</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">47M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item" style="border-bottom: 1px solid #ddd">
        <div class="form-group form-check mb-0">
          <input type="checkbox" class="form-check-input" id="exampleCheck1" />
          <label class="form-check-label" for="exampleCheck1">
            <h5>DKI Jakarta</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">45M</span>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="form-group form-check mb-0">
          <input type="checkbox" class="form-check-input" id="exampleCheck1" />
          <label class="form-check-label" for="exampleCheck1">
            <h5>Jawa Barat</h5>
          </label>
          <div class="float-right">
            <span class="custom-right-val">44M</span>
          </div>
        </div>
      </li>
      <!-- <li class="list-group-item" style="border-bottom: 1px solid #ddd">
            <div class="form-group form-check mb-0">
              <input
                type="checkbox"
                class="form-check-input"
                id="exampleCheck1"
              />
              <label class="form-check-label" for="exampleCheck1">
                <h5>Jawa Tengah</h5>
              </label>
              <div class="float-right">
                <span class="custom-right-val">42M</span>
              </div>
            </div>
          </li>
          <li class="list-group-item" style="border-bottom: 1px solid #ddd">
            <div class="form-group form-check mb-0">
              <input
                type="checkbox"
                class="form-check-input"
                id="exampleCheck1"
              />
              <label class="form-check-label" for="exampleCheck1">
                <h5>DI Yogyakarta</h5>
              </label>
              <div class="float-right">
                <span class="custom-right-val">398K</span>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="form-group form-check mb-0">
              <input
                type="checkbox"
                class="form-check-input"
                id="exampleCheck1"
              />
              <label class="form-check-label" for="exampleCheck1">
                <h5>Jawa Timur</h5>
              </label>
              <div class="float-right">
                <span class="custom-right-val">200K</span>
              </div>
            </div>
          </li> -->
    </ul>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.list-group-item {
  border: none;
}
.custom-right-val {
  flex: 0;
  font-size: 14px;
  font-weight: 400;
  color: #6e87a2;
}
.playground .left-title {
  font-weight: 700;
  font-size: clamp(16px, 1.5vw, 19px);
  line-height: clamp(18px, 1.7vw, 23px);
  color: #1d3d63;
}
.playground .left-download {
  color: #1d3d63;
  font-size: 13px;
}
.form-control-xs {
  height: calc(1em + 0.375rem + 10px) !important;
  padding: 0.125rem 0.25rem !important;
  font-size: 0.9rem !important;
  font-weight: bolder;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.col-form-label-xs {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
</style>
